import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import * as Business from '../../utils/business';
import UpdatePassword from '../../pages/User/UpdatePassword'
import * as Http from '../../http'

class VersionInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      bizVersion: '',
      webVersion: '25.0304.0800',
    }
    this.getVersion = this.getVersion.bind(this);

  }

  componentDidMount() {
    this.getVersion();
  }

  getVersion = () => {
    this.setState({
      bizVersion: '',
      loading: true
    }, () => {
      Http.getVersion()
        .then(res => {
          if (res && res.Success) {
            if (res.Data) {
              this.setState({
                bizVersion: res.Data ? res.Data : '',
                loading: false
              })
            }
          }
        })
    })
  }

  render() {
    return (
      <div style={{ position: 'absolute', bottom: 0, width: '100%', height: '25px', textAlign: 'center', color: '#8d8d8d' }}>
        <span>Version: {this.state.bizVersion}</span> <span>#</span> <span>{this.state.webVersion}</span>
      </div>
    );
  }
}

export default VersionInfo;


// WEBPACK FOOTER //
// ./src/components/SideBar/VersionInfo.js